var VehicleUpdatesCtrl = function ($scope, $log, customerModelService) {

    $scope.toggleUpdatesPopup = function () {
        $scope.showUpdatesPopup = !$scope.showUpdatesPopup;
    };

    //init
    //
    //@description
    //entry point into the controller cient logic
    function init() {
        $scope.recallsAvailable = false;
        $scope.showVehicleAlerts = window.appSettings.ossShowVehicleAlerts;
        $scope.vehicleAlertsAvailable = false;
        $scope.vehicleAlerts = [];
        $scope.recalls = customerModelService.getMergedRecalls();
        $scope.vehicleAlertsPending = false;

        if ($scope.recalls.length > 0) {
            $scope.recallsAvailable = true;
        }

        if ($scope.showVehicleAlerts) {
            $scope.vehicleAlertsPending = true;
            if (customerModelService.areVehicleAlertsLoaded()) {
                // Reuse alerts if they have been loaded before
                $scope.vehicleAlerts = customerModelService.getMergedAlerts();
                $scope.vehicleAlertsPending = false;
            } else {
                customerModelService.resolveAlertsUpdates()
                    .then(function (alerts) {
                        $scope.vehicleAlerts = customerModelService.getMergedAlerts();

                        if (alerts.length > 0) {
                            $scope.vehicleAlertsAvailable = true;
                        }
                    })
                    .catch(function (error) {
                        $log.error('Failed to get vehicle alerts', error);
                        $scope.vehicleAlerts = [];
                    })
                    .finally(function () {
                        $scope.vehicleAlertsPending = false;
                    });
            }
        }

        if ($scope.vehicleAlerts.length > 0) {
            $scope.vehicleAlertsAvailable = true;
        }
    }

    init();
};

VehicleUpdatesCtrl.$inject = ['$scope', '$log', 'customerModelService'];

module.exports = VehicleUpdatesCtrl;
